<template>
    <v-container fluid>
        <v-row class="align-center mb-2">
            <v-col cols="auto">
                <h2 class="text-h6">Storico manutenzioni</h2>
            </v-col>
            <v-spacer />
            <v-col cols="auto">
                <v-btn variant="outlined" prepend-icon="mdi-file-excel" class="mr-2" @click="esportaExcel">
                    Excel
                </v-btn>
                <v-btn variant="outlined" prepend-icon="mdi-file-pdf-box" @click="esportaPdf">
                    PDF
                </v-btn>
            </v-col>
        </v-row>

        <v-row class="mb-2">
            <v-col cols="12" sm="4" md="3">
                <v-select v-model="filtro.macchinaId" :items="macchine" item-title="nome" item-value="id"
                    label="Macchina" density="compact" hide-details clearable @update:modelValue="carica" />
            </v-col>
            <v-col cols="12" sm="4" md="3">
                <v-text-field v-model="filtro.dataInizio" type="date" label="Dal" density="compact" hide-details
                    @update:modelValue="carica" />
            </v-col>
            <v-col cols="12" sm="4" md="3">
                <v-text-field v-model="filtro.dataFine" type="date" label="Al" density="compact" hide-details
                    @update:modelValue="carica" />
            </v-col>
        </v-row>

        <v-data-table :headers="headers" :items="righe" :items-per-page="20" density="comfortable">
            <template #[`item.dataPrevista`]="{ item }">{{ formattaData(item.dataPrevista) }}</template>
            <template #[`item.dataCompletamento`]="{ item }">{{ formattaData(item.dataCompletamento) }}</template>
        </v-data-table>
    </v-container>
</template>

<script>
import { get_storico, export_storico_excel, export_storico_pdf, scaricaBlob } from "@/api/api.storico.js";
import { leggiFiltriDaQuery, scriviFiltriSuQuery } from "@/utils/filtriUrl.js";

export default {
    name: "StoricoPage",

    data() {
        return {
            righe: [],
            filtro: {
                macchinaId: null,
                dataInizio: null,
                dataFine: null,
            },
            headers: [
                { title: "Macchina", key: "macchinaNome" },
                { title: "Reparto", key: "repartoNome" },
                { title: "Tipo", key: "tipoManutenzioneNome" },
                { title: "Data prevista", key: "dataPrevista" },
                { title: "Completata il", key: "dataCompletamento" },
                { title: "Eseguita da", key: "eseguitaDaNome" },
                { title: "Ricambi usati", key: "ricambiUsatiRiepilogo" },
            ],
        };
    },

    computed: {
        macchine() {
            return this.$store.getters["macchine/lista"];
        },
    },

    mounted() {
        Object.assign(this.filtro, leggiFiltriDaQuery(this.$route, {
            macchinaId: "number",
            dataInizio: "string",
            dataFine: "string",
        }));
        this.$store.dispatch("macchine/carica");
        this.carica();
    },

    methods: {
        async carica() {
            scriviFiltriSuQuery(this.$router, this.$route, this.filtro);
            try {
                const res = await get_storico(this.filtro);
                this.righe = res.data;
            } catch (error) {
                console.log(error);
            }
        },

        async esportaExcel() {
            try {
                const res = await export_storico_excel(this.filtro);
                scaricaBlob(res.data, "storico-manutenzioni.xlsx");
            } catch (error) {
                console.log(error);
            }
        },

        async esportaPdf() {
            try {
                const res = await export_storico_pdf(this.filtro);
                scaricaBlob(res.data, "storico-manutenzioni.pdf");
            } catch (error) {
                console.log(error);
            }
        },

        formattaData(data) {
            return data ? new Date(data).toLocaleDateString("it-IT") : "";
        },
    },
};
</script>